import React, { FunctionComponent, useCallback } from "react";
import { useTranslation } from "react-i18next";

import { HashStateHookResult } from "../../stores/useHashState";
import { Button } from "../../ui/Button/Button";
import { DownloadIcon } from "../../ui/icons/DownloadIcon";
import { EnvelopeLiteIcon } from "../../ui/icons/EnvelopeLiteIcon";
import { PrinterIcon } from "../../ui/icons/PrinterIcon";
import { useLeadFormModalState } from "./LeadFormModal";

export const LeadFormButtons: FunctionComponent = () => {
  const { t } = useTranslation();

  const downloadState = useLeadFormModalState("#download");
  const emailState = useLeadFormModalState("#email");
  const printState = useLeadFormModalState("#print");

  const makeHandler = useCallback(
    (state: HashStateHookResult) => () => {
      const [, { show }] = state;
      show();
    },
    []
  );

  return (
    <nav className="flex space-x-1 row-start-1 md:row-start-2 justify-end">
      <Button
        aria-label="openDownloadDialog"
        className="font-thin text-ink-2 px-2 md:px-4"
        element="a"
        onClick={makeHandler(downloadState)}
      >
        <DownloadIcon />
        <span className="hidden md:inline">{t("leadForm.download")}</span>
      </Button>
      <Button
        aria-label="openEmailDialog"
        className="font-thin text-ink-2 px-2 md:px-4"
        onClick={makeHandler(emailState)}
      >
        <EnvelopeLiteIcon />
        <span className="hidden md:inline">{t("leadForm.email")}</span>
      </Button>
      <Button
        aria-label="openPrintDialog"
        className="font-thin text-ink-2 px-2 md:px-4"
        onClick={makeHandler(printState)}
      >
        <PrinterIcon />
        <span className="hidden md:inline">{t("leadForm.print")}</span>
      </Button>
    </nav>
  );
};
